import React from 'react';
import { FaServer, FaGlobe, FaEnvelope, FaQuestionCircle } from 'react-icons/fa';
import { MdDomain } from 'react-icons/md';
import { Link } from 'react-router-dom';

const Hosting = () => {
  return (
    <div className='min-h-screen bg-gray-50 p-8'>
      <h1 className="text-2xl text-customRed font-bold mb-8 text-center">Hosting Services</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <ServiceCard
          icon={<FaServer />}
          title="Host"
          image="/images/host.jpeg"
          description="Manage and maintain your hosting infrastructure for optimal performance."
        />
        <ServiceCard
          icon={<MdDomain />}
          title="DOMAIN NAME REGISTRATION"
          image="/images/domain.jpeg"
          description="Register and manage domain names for your websites and applications."
        />
        <ServiceCard
          icon={<FaGlobe />}
          title="WEBSITE HOSTING"
          image="/images/webhosting.jpeg"
          description="Host your websites on reliable servers with high availability and security."
        />
        <ServiceCard
          icon={<FaEnvelope />}
          title="EMAIL HOSTING"
          image="/images/email.jpeg"
          description="Provide email hosting solutions with robust features and spam protection."
        />
      </div>
    </div>
  );
}

const ServiceCard = ({ icon, title, image, description }) => {
  const handleEnquiryClick = () => {
    // Replace with your actual enquiry handling logic
    window.location.href = '/contact';
  };

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <div className="relative h-48">
        <img src={image} alt={title} className="object-cover w-full h-full" />
        <div className="absolute inset-0 bg-black opacity-60"></div>
        <div className="absolute inset-0 flex items-center justify-center text-white">
          <div className="text-center px-4">
            <div className="text-3xl mb-2">{icon}</div>
            <h2 className="text-xl font-semibold mb-2">{title}</h2>
            <p className="text-md">{description}</p>
          </div>
        </div>
      </div>
      <div className="p-4 flex justify-center">
      <Link
        to="/contact"
        className="block bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-md flex items-center justify-center transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <span className="flex justify-center items-center">
          <FaQuestionCircle className="mr-2" /> Enquire
        </span>
      </Link>
    </div>
    </div>
  );
}

export default Hosting;
